import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { SlideLessonPageContextValue } from "#slide-lesson-page-context-value";

export const SlideLessonPageContext = createContext(
  defaultError<SlideLessonPageContextValue>("SlideLessonPageContext"),
);
